import React from "react";

import { IconMainMenuMonitors } from "~/components/icon";

import { BREADCRUMB_ICON_CLASS } from "../../../components/react/icon/Icon";
import { useNavigateToLink } from "../../../components/react/link";
import { MONITORS_PATH } from "../../Routes";
import { BreadcrumbLayout } from "../BreadcrumbLayout";

export const MonitorsIndexBreadcrumb: React.FC = () => {
	const link = useNavigateToLink(MONITORS_PATH, {
		search: ["timeRange", "timestamp", "detachedFilters"],
		params: {},
	});

	return (
		<BreadcrumbLayout icon={<IconMainMenuMonitors className={BREADCRUMB_ICON_CLASS} />} label="Monitors" to={link} />
	);
};
